import { getCurrentInstance, ComponentInternalInstance } from 'vue';
export default function useGetGlobalProperties() {
  const { appContext } = getCurrentInstance() as ComponentInternalInstance;

  return { ...appContext.config.globalProperties };
}
